module.exports = __webpack_public_path__ + "img/reporting_posts_reaction.28a34749.svg";